import apiClient from "./base.service";

export default {
    async update(data) {
        return await apiClient.put(`/config`, data);
    },
    async get() {
        return await apiClient.get(`/config`);
    }
}